import { GetProgramsQuery } from "~/gql/queries/programs.generated";

export const programsEndpoints = {
	GetPrograms: {
		providesTags: ["Programs"] as AddTagTypes,
		transformResponse: (res: GetProgramsQuery) => res
	}
};
